var LocalStorage = (function() {
  var isSupported = false;
  try {
    isSupported = window.localStorage ? true : false;
  } 
  catch (error) {}

  return {
    isSupported: isSupported,
    set: function(key, val) {
      if(isSupported) {
        localStorage.setItem(key, val);
      }
    },
    get: function(key) {
      if(isSupported) {
        return localStorage.getItem(key);
      }
    },
    remove: function(key) {
      if(isSupported) {
        return localStorage.removeItem(key);
      }
    }
  }
})();